module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO SOCIALMEDIA_DESTAQUES-6221a3865b2d93d07e8e2ae6f88aacce.png";